// 매물 문의 실시간 인앱 팝업 (#6b, 2026-05-26) — 업체 ERP 열림 상태 한정.
// Socket 'inquiry:new'(신규 문의) + 'inquiry:message'(바이어 답장) → 우하단 토스트 + Desktop Notification + 확인하기.
// cancel_agency 제외 (매물 문의 수신 대상 = 관리자/서류대행/일반 업체). CancelAgencyLivePopup 패턴 복제(비차단 토스트).
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSocket } from '../utils/socket';

function InquiryLivePopup(props) {
  var user = props.user;
  var queueState = useState([]);
  var queue = queueState[0];
  var setQueue = queueState[1];
  var navigate = useNavigate();
  var seqRef = useRef(0);

  useEffect(function() {
    if (!user || user.role === 'cancel_agency') return;
    var sock = getSocket();
    if (!sock) return;

    // 브라우저 알림 권한 요청 (비동기)
    try {
      if (typeof Notification !== 'undefined' && Notification.permission === 'default') {
        Notification.requestPermission();
      }
    } catch (e) {}

    function makeHandler(type) {
      return function(data) {
        var key = 'inq-' + (data && data.inquiryId) + '-' + (seqRef.current++);
        var isReply = type === 'message';
        var item = {
          key: key,
          type: type,
          title: isReply ? '💬 새 문의 답장' : '📨 새 매물 문의',
          carNo: (data && data.carNo) || '',
          carType: (data && data.carType) || '',
          carId: data && data.carId,
        };
        setQueue(function(prev) { return prev.concat([item]); });

        // 데스크톱 알림
        try {
          if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
            var body = (item.carNo || ('차량 #' + (item.carId || ''))) + (item.carType ? ' · ' + item.carType : '');
            new Notification(item.title, { body: body, icon: '/autodex-icon.svg', tag: key });
          }
        } catch (e) {}

        // 8초 후 자동 사라짐
        setTimeout(function() {
          setQueue(function(prev) { return prev.filter(function(x) { return x.key !== key; }); });
        }, 8000);
      };
    }
    var onNew = makeHandler('new');
    var onMessage = makeHandler('message');

    sock.on('inquiry:new', onNew);
    sock.on('inquiry:message', onMessage);
    return function() { try { sock.off('inquiry:new', onNew); sock.off('inquiry:message', onMessage); } catch (e) {} };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user && user.role]);

  if (!user || user.role === 'cancel_agency' || queue.length === 0) return null;

  function dismiss(key) {
    setQueue(function(prev) { return prev.filter(function(x) { return x.key !== key; }); });
  }
  function goInbox() {
    setQueue([]);
    navigate('/main/inquiries');
  }

  return (
    <div style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 10001, display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 320 }}>
      {queue.map(function(it) {
        return (
          <div key={it.key} style={{ background: '#fff', border: '1px solid #e2e8f0', borderLeft: '4px solid #2563eb', borderRadius: 12, boxShadow: '0 8px 24px rgba(0,0,0,0.18)', padding: '12px 14px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <span style={{ fontSize: 13, fontWeight: 800, color: '#1B3A5C' }}>{it.title || '📨 새 매물 문의'}</span>
              <span onClick={function(){ dismiss(it.key); }} style={{ cursor: 'pointer', color: '#94a3b8', fontSize: 13, padding: '0 4px' }}>✕</span>
            </div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a' }}>{it.carNo || ('차량 #' + (it.carId || ''))}</div>
            {it.carType ? <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{it.carType}</div> : null}
            <button onClick={goInbox} style={{ marginTop: 10, width: '100%', height: 34, border: 'none', borderRadius: 8, background: '#2563eb', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>확인하기</button>
          </div>
        );
      })}
    </div>
  );
}

export default InquiryLivePopup;
